// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"SliderSpectacles_sliderWrapper__ThIBE","swiper":"SliderSpectacles_swiper__V4yM+","slide":"SliderSpectacles_slide__O8g8z"};